export const config = {
  apiKey: 'AIzaSyBppBDnPTQMqo2YLDDUTaXVJN4jZuGRwOw',
  authDomain: 'uta-gasp-silko.firebaseapp.com',
  databaseURL: 'https://uta-gasp-silko.firebaseio.com',
  projectId: 'uta-gasp-silko',
  storageBucket: 'uta-gasp-silko.appspot.com',
  messagingSenderId: '312523900223',
};



// WEBPACK FOOTER //
// ./src/config/db.production.js